import { styled, css } from 'app/pages/request-single-page/components-v4/theme';

export const HeaderWrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings.base};

    ${theme.tokens.media.tablet} {
      padding-block: ${theme.spacings.base};
      padding-inline: ${theme.spacings.l};
    }

    ${theme.tokens.media.down('desktop')} {
      position: sticky;
      top: 0;
      z-index: 1;
      background-color: ${theme.colors.white};
    }
  `}
`;

export const MobileHeader = styled.div`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    align-items: center;
    gap: ${theme.spacings.base};
  `}
`;

export const MobileHeaderClose = styled.div`
  ${({ theme }) => css`
    position: absolute;
    left: 0;
    display: flex;
    align-items: center;
    gap: ${theme.spacings.xxs};
    color: ${theme.colors.primary[600]};
    cursor: pointer;
  `}
`;
